import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

function MagicWandIcon(props: SvgIconProps): React.ReactElement {
  return (
    <SvgIcon viewBox="0 0 20 20" {...props}>
      <path
        d="m16.667 5.834.783-1.717 1.717-.783-1.717-.783-.783-1.717-.784 1.717-1.716.783 1.716.783zm-9.584 0 .784-1.717 1.716-.783-1.716-.783L7.083.834 6.3 2.551l-1.717.783 1.717.783zm9.584 4.583-.784 1.717-1.716.783 1.716.784.784 1.716.783-1.716 1.717-.784-1.717-.783zM14.758 7.6 12.4 5.243a.85.85 0 0 0-.592-.241.85.85 0 0 0-.591.241l-9.309 9.309a.83.83 0 0 0 0 1.175l2.359 2.358c.166.167.375.25.591.25a.85.85 0 0 0 .592-.242l9.308-9.308a.84.84 0 0 0 0-1.183m-2.95-.583 1.175 1.175-.975.975-1.175-1.175zm-6.95 9.309L3.683 15.15l5.975-5.984 1.175 1.175z"
        fill="#2e7ea8"
      />
    </SvgIcon>
  );
}

export default MagicWandIcon;
